import { Controller } from "@hotwired/stimulus"

// Thin bridge between Rails-rendered chrome (Add Node dropdown) and the
// React island inside this same page. The React canvas listens on `window`
// for `gtm:add-step` and creates the step server-side.
export default class extends Controller {
  static targets = ["host"]

  addNode(event) {
    const type = event.params.type
    if (!type) return
    window.dispatchEvent(new CustomEvent("gtm:add-step", { detail: { type } }))
  }

  // Done link click: hand the destination URL to React so it can flush any
  // dirty layout changes before we leave the page.
  saveAndLeave(event) {
    event.preventDefault()
    const href = event.currentTarget.getAttribute("href")
    window.dispatchEvent(new CustomEvent("gtm:save-and-leave", { detail: { href } }))
  }
}
